import type { ClientPortfolioDetailCoDebtorResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { EMPTY_CO_DEBTOR as DEFAULTS } from "web_myplann/Portfolio/Forms/CoDebtors/coDebtorsSchema";

export const mapCoDebtorsToForm = (
	coDebtors: ClientPortfolioDetailCoDebtorResponseDTO[] | undefined,
) =>
	(coDebtors ?? []).map((coDebtor) => ({
		id: coDebtor.id ?? DEFAULTS.id,
		firstname: coDebtor.firstname ?? DEFAULTS.firstname,
		lastname: coDebtor.lastname ?? DEFAULTS.lastname,
		identification: coDebtor.identification ?? DEFAULTS.identification,
	}));
